(() => {
  const formatDuration = (seconds) => {
    if (!Number.isFinite(seconds) || seconds < 0) return '—:—';
    const total = Math.ceil(seconds);
    const mins = Math.floor(total / 60);
    const secs = total % 60;
    return `${mins}:${String(secs).padStart(2, '0')}`;
  };

  const parseTimeLabel = (label) => {
    const match = /^(\d+):(\d{2})$/.exec(String(label || '').trim());
    if (!match) return null;
    return Number(match[1]) * 60 + Number(match[2]);
  };

  const extractDriveId = (url) => {
    if (!url) return '';
    const fileMatch = String(url).match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
    if (fileMatch) return fileMatch[1];
    const idMatch = String(url).match(/[?&]id=([a-zA-Z0-9_-]+)/);
    return idMatch ? idMatch[1] : '';
  };

  const initListenPlayer = (root) => {
    const player = root.querySelector('.brand-daily__listen');
    const button = root.querySelector('.brand-daily__play');
    const audio = root.querySelector('.brand-daily__audio');
    const driveFrame = root.querySelector('.brand-daily__drive-frame');
    const durationEl = root.querySelector('.brand-daily__audio-duration');

    if (!player || !button) return;
    if (player.dataset.bound === 'true') return;
    player.dataset.bound = 'true';

    const driveId = player.dataset.driveId || extractDriveId(audio?.getAttribute('src'));
    const isDrive = Boolean(driveId);

    const initialLabel = durationEl?.textContent?.trim() || '—:—';
    let totalSeconds = parseTimeLabel(initialLabel);
    let tickTimer = null;

    const setPlaying = (playing) => {
      player.classList.toggle('is-playing', playing);
      button.setAttribute('aria-pressed', playing ? 'true' : 'false');
    };

    const showTotalDuration = () => {
      if (!durationEl) return;
      if (totalSeconds != null && totalSeconds > 0) {
        durationEl.textContent = formatDuration(totalSeconds);
        durationEl.dataset.durationReady = 'true';
      } else {
        durationEl.textContent = initialLabel;
      }
    };

    const clearTick = () => {
      if (tickTimer) {
        clearInterval(tickTimer);
        tickTimer = null;
      }
    };

    const startDurationTick = () => {
      clearTick();
      if (!durationEl || !totalSeconds || totalSeconds <= 0) return;

      let remaining = totalSeconds;
      durationEl.textContent = formatDuration(remaining);

      tickTimer = setInterval(() => {
        remaining -= 1;
        if (remaining <= 0) {
          resetPlayer();
          return;
        }
        durationEl.textContent = formatDuration(remaining);
      }, 1000);
    };

    const stopDrive = () => {
      if (driveFrame) driveFrame.src = 'about:blank';
    };

    const startDrive = () => {
      if (!driveFrame) return;
      driveFrame.src = `https://drive.google.com/file/d/${encodeURIComponent(driveId)}/preview`;
    };

    const resetPlayer = () => {
      clearTick();
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
      stopDrive();
      setPlaying(false);
      showTotalDuration();
    };

    const syncTotalFromAudio = () => {
      if (!audio || !Number.isFinite(audio.duration) || audio.duration <= 0) return;
      totalSeconds = audio.duration;
      if (!player.classList.contains('is-playing')) {
        showTotalDuration();
      }
    };

    button.addEventListener('click', async () => {
      if (isDrive) {
        if (player.classList.contains('is-playing')) {
          resetPlayer();
        } else {
          startDrive();
          setPlaying(true);
          startDurationTick();
        }
        return;
      }

      if (!audio || !audio.getAttribute('src')) return;

      try {
        if (audio.paused) {
          syncTotalFromAudio();
          await audio.play();
          setPlaying(true);
        } else {
          resetPlayer();
        }
      } catch {
        resetPlayer();
      }
    });

    if (isDrive) {
      showTotalDuration();
      return;
    }

    if (!audio) return;

    audio.addEventListener('loadedmetadata', syncTotalFromAudio);
    audio.addEventListener('durationchange', syncTotalFromAudio);

    audio.addEventListener('timeupdate', () => {
      if (!durationEl || audio.paused || !Number.isFinite(audio.duration)) return;
      const remaining = Math.max(0, audio.duration - audio.currentTime);
      durationEl.textContent = formatDuration(remaining);
    });

    audio.addEventListener('ended', resetPlayer);

    try {
      audio.load();
    } catch {
      /* ignore */
    }

    syncTotalFromAudio();
    showTotalDuration();
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('.brand-daily-listen').forEach(initListenPlayer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target?.classList?.contains('brand-daily-listen')) {
      boot(target);
      return;
    }
    const section = target?.querySelector?.('.brand-daily-listen');
    if (section) boot(section);
  });
})();